import { Blob, BlobHistory, Finding } from '@consigli/types';

export const createBlobsExcelExport = (blobs: Blob[], projectName: string) => {
  const title = projectName;
  const headers = [
    'ID',
    'Project ID',
    'Package ID',
    'Name',
    'Extension',
    'Parsed Status',
    'NS3451',
    'Original File ID',
    'MD5',
    'Name Suggestion',
  ];
  const data = blobs.map((blob) => {
    return [
      blob.id,
      blob.project,
      blob.documentPackage,
      blob.name,
      blob.extension,
      blob.parsedStatus,
      blob.ns3451.join(', '),
      blob.originalFileId,
      blob.md5 ? blob.md5 : '',
      blob.nameSuggestion ? blob.nameSuggestion : '',
    ];
  });
  return { title, headers, data };
};

export const createFindingsExcelExport = (findings: Finding[], projectName: string) => {
  const title = projectName;
  const headers = [
    'ID',
    'Status',
    'Conflict Type',
    'Conflict Category',
    'Content',
    'Message Context',
    'Message Template',
    'Page Number',
    'Project ID',
    'Package ID',
    'File ID',
    'File Name',
    'Processor Name',
    'REF File ID',
    'REF File Name',
    'REF Content',
    'REF Page Number',
  ];
  const data = findings.map((finding) => {
    return [
      finding.id,
      finding.status,
      finding.conflictType,
      finding.conflictCategory,
      finding.content ? finding.content : '',
      JSON.stringify(finding.messageContext),
      finding.messageTemplate,
      finding.pageNumber !== null && finding.pageNumber !== undefined ? finding.pageNumber + 1 : '',
      finding.projectId,
      finding.documentPackageId,
      finding.blobId ? finding.blobId : '',
      finding.fileName ? finding.fileName : '',
      finding.processorName ? finding.processorName : '',
      finding.refBlobId ? finding.refBlobId : '',
      finding.refFileName ? finding.refFileName : '',
      finding.refContent ? finding.refContent : '',
      finding.refPageNumber !== null && finding.refPageNumber !== undefined
        ? finding.refPageNumber + 1
        : '',
    ];
  });
  return { title, headers, data };
};

export const createBlobHistoryExcelExport = (blobHistories: BlobHistory[], projectName: string) => {
  const title = projectName;
  const headers = [
    'Blob ID',
    'Blob Name',
    'From NS3451',
    'Updated by',
    'To NS3451',
    'Updated by',
    'From Document Type',
    'Updated by',
    'To Document Type',
    'Updated by',
  ];
  const data = blobHistories.map((history) => {
    return [
      history.blobId,
      history.blobName,
      history.ns3451.from.value ? history.ns3451.from.value.toString() : '',
      history.ns3451.from.createdBy ? history.ns3451.from.createdBy : '',
      history.ns3451.to.value ? history.ns3451.to.value.toString() : '',
      history.ns3451.to.createdBy ? history.ns3451.to.createdBy : '',
      history.documentType.from.value ? history.documentType.from.value.toString() : '',
      history.documentType.from.createdBy ? history.documentType.from.createdBy : '',
      history.documentType.to.value ? history.documentType.to.value.toString() : '',
      history.documentType.to.createdBy ? history.documentType.to.createdBy : '',
    ];
  });
  return { title, headers, data };
};
